import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UIComponents, log } from '@ntap/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pregled-gradiva-po-roku-cuvanja',
  templateUrl: './pregled-gradiva-po-roku-cuvanja.component.html',
  styleUrls: ['./pregled-gradiva-po-roku-cuvanja.component.scss']
})
export class PregledGradivaPoRokuCuvanjaComponent implements OnInit, OnDestroy {
  INIT_COMP_ID = UIComponents.LISTVIEW;
  jediniceViewName: string;
  jediniceViewState: object | null = null;
  jediniceViewStateFilter: object = {};

  routeChangeSubscription: Subscription;

  constructor(protected route: ActivatedRoute) {}

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  ngOnDestroy(): void {
    this.unsubscribeFromRouteChange();
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.routeChangeSubscription = this.route.data.subscribe(() => {
      log('param change');
      this.changeView();
    });
  }

  unsubscribeFromRouteChange(): any {
    log('Unsubsubscribe from route params');
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  changeView() {
    this.jediniceViewName = 'jedinice_gradiva_po_roku_cuvanja';
    this.jediniceViewState = {};
    this.jediniceViewStateFilter = {};
  }
}
